import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AboutPageComponent} from './pages/about-page/about-page.component';
import {FaqPageComponent} from './pages/faq-page/faq-page.component';
import {ContactUsComponent} from './pages/contact-us/contact-us.component';
import {AuthGuard} from './ff-shared/auth.guard';
import {HomeComponent} from './pages/home/home.component';
import {ThankYouComponent} from './auth/register/thank-you/thank-you.component';
import {TermsComponent} from './terms/terms.component';
import {IsraeliOnlyGuard} from './guards/israeli-only.guard';
import {VehicleEuStandardInfoComponent} from './vehicle-eu-standard-info/vehicle-eu-standard-info.component';
import {CarsGridPubComponent} from './cars-market/cars-grid-pub/cars-grid-pub.component';
import {CarsGridComponent} from './cars/cars-grid/cars-grid.component';
import {CarsGridComponent as MyCarsGridComponent} from './cars/my-list/cars-grid/cars-grid.component';
import { AccesabilityStatementComponent } from './accesability-statement/accesability-statement.component';
import {CarsGridCollComponent} from './cars/cars-grid-coll/cars-grid-coll.component';
import {CarsGridCollPubComponent} from './cars-market/cars-grid-coll-pub/cars-grid-coll-pub.component';
import { CarOverviewComponent } from './cars/car-overview/car-overview.component';
import {CarsGridSellerComponent} from './cars-seller/cars-grid-seller/cars-grid-seller.component';
import {CarsGridSellerUaeComponent} from './cars-seller-uae/cars-grid-seller-uae/cars-grid-seller-uae.component';
import {CarsGridSellerGaComponent} from './cars-seller-ga/cars-grid-seller-ga/cars-grid-seller-ga.component';
import {CarsGridSellerNigeriaComponent} from './cars-seller-nigeria/cars-grid-seller-nigeria/cars-grid-seller-nigeria.component';


const routes: Routes = [
    {path: '', redirectTo: 'car-market', pathMatch: 'full'},
    {path: 'home', component: HomeComponent},
    {path: 'about', component: AboutPageComponent},
    {path: 'faq', component: FaqPageComponent},
    {path: 'AccesabilityStatement', component: AccesabilityStatementComponent},

    {path: 'contact', component: ContactUsComponent},
    {path: 'thankyou', component: ThankYouComponent},
    {path: 'car-market', component: CarsGridPubComponent},
    {path: 'naor', component: CarsGridSellerComponent},
    {path: 'uae', component: CarsGridSellerUaeComponent},
    {path: 'ga', component: CarsGridSellerGaComponent},
    {path: 'nigeria', component: CarsGridSellerNigeriaComponent},
    {path: 'car-overview', component: CarOverviewComponent},
    {path: 'car-market-coll', component: CarsGridCollPubComponent},
    {path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)},
    {path: 'terms', component: TermsComponent, canActivate: [IsraeliOnlyGuard]},
    {
        path: 'account',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path: 'cars',
        component: CarsGridComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard]
    },
    {
      path: 'cars-coll',
      component: CarsGridCollComponent,
      canActivate: [AuthGuard],
      canActivateChild: [AuthGuard]
    },
    {
        path: 'cars/my-list',
        component: MyCarsGridComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard]
    },
    // {
    //   path: 'cars',
    //   canActivate: [AuthGuard],
    //   canActivateChild: [AuthGuard],
    //   loadChildren: () => import('./cars/cars.module').then(m => m.CarsModule)
    // },
    {
        path: 'cert-check',
        canActivate: [AuthGuard],  // Optional
        component: VehicleEuStandardInfoComponent
    },
    { path: 'stellantis', loadChildren: () => import('./stellantis/stellantis.module').then(m => m.StellantisModule) },
    { path: 'subscribe',
      // canActivate: [AuthGuard],
      // canActivateChild: [AuthGuard],
      loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
